import { toast } from 'react-toastify';

export const TX_STATUS_TOAST_ID = 'txInfo';

const baseConfig = {
  position: toast.POSITION.TOP_RIGHT,
  autoClose: 12 * 1000,
  closeOnClick: true,
  newestOnTop: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  hideProgressBar: true,
  theme: 'dark',
}

const toastConfig = {
  default: {
    ...baseConfig,
  },
  transaction: {
    ...baseConfig,
    toastId: TX_STATUS_TOAST_ID,
    closeOnClick: false,
    hideProgressBar: false,
  },
  worldTimeWarn: {
    ...baseConfig,
    toastId: 'WorldTimeFallbackMessage',
  },
}


export default toastConfig;